import React from "react";

function ResumeButton() {
  return (
    <div className="text-center mt-8">
      <a
        href="/LuisTorreResume.pdf"
        download="LuisTorre_Resume.pdf"
        className="inline-block bg-gray-600 text-white font-semibold py-3 px-6 
                   rounded-lg shadow-md transition-all duration-300 
                   hover:bg-blue-700 hover:shadow-lg"
      >
        Download My Resume
      </a>
    </div>
  );
}

export default ResumeButton;
